import React from 'react';
import { Link } from 'react-router-dom';
import autoBind from 'react-autobind';
import authLib from '../../lib/auth';
import { appContainer } from '../../contexts/app';
import FlatButton from 'material-ui/FlatButton';
import Subheader from 'material-ui/Subheader';
import { ToolbarGroup } from 'material-ui/Toolbar';
import Popover from 'material-ui/Popover';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';

import style from './style.js';

class AccountDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
    autoBind(this);
  }

  openPopover(event) {
    // prevDefault prevents "ghost click", as per Popover docs
    event.preventDefault();
    this.setState({
      popoverOpen: true,
      anchorEl: event.currentTarget
    });
  }

  closePopover() {
    this.setState({ popoverOpen: false });
  }

  openTrainingModal() {
    appContainer.set('trainingModalOpen', true);
    this.setState({ popoverOpen: false });
  }

  logOut() {
    authLib.logOut();
  }

  switchAccounts(session) {
    authLib.become(session);
  }

  render() {
    const { currentUser, sessions, windowWidth, notExpired } = this.props;
    return (
      <div>
        <FlatButton
          // secondary
          onClick={this.openPopover}
          label={windowWidth >= 590 ? currentUser.full_name : ''}
          labelPosition="before"
          labelStyle={style.accountLabel}
          style={{ height: 46 }}
          icon={<Avatar size={40} src={currentUser.image.path} />}
        />
        <Popover
          style={{ minWidth: 137 }}
          open={this.state.popoverOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.closePopover}
        >
          <List className="overflowHidden" style={style.overflowHidden}>
            <ListItem
              onClick={this.closePopover}
              primaryText="Account"
              containerElement={<Link to="/account" />}
            />
            <Divider />
            <ListItem
              onClick={this.closePopover}
              primaryText="Help"
              containerElement={
                //eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  href="https://mapplug.zendesk.com"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              }
            />
            {notExpired ? (
              <ListItem
                onClick={this.openTrainingModal}
                primaryText="Training"
              />
            ) : null}
            <Divider />
            <ListItem onClick={this.logOut} primaryText="Log Out" />
            {sessions.size > 1 && (
              <div>
                <Divider />
                <Subheader>Switch Accounts</Subheader>
                <List style={style.scrollAccountList}>
                  {sessions.map(session => (
                    <ListItem
                      key={session.account_id}
                      primaryText={session.account_name}
                      onClick={() => this.switchAccounts(session)}
                    />
                  ))}
                </List>
              </div>
            )}
          </List>
        </Popover>
      </div>
    );
  }
}

export default class AccountBar extends React.Component {
  render() {
    const { sessions, currentUser, windowWidth, notExpired } = this.props;
    return (
      <ToolbarGroup style={style.accountWide}>
        <div style={{ marginLeft: 'auto' }}>
          <AccountDropDown
            windowWidth={windowWidth}
            currentUser={currentUser}
            sessions={sessions}
            notExpired={notExpired}
          />
        </div>
      </ToolbarGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NavBar/AccountBar.js